import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { keysToSnakeCase } from '@hotjar/insights-common/lib/convert-string';
import type { TransferAccountOwnershipResponse } from './types';

export const transferAccountOwnership = (
  accountId: number,
  newOwnerId: number,
  password: string,
): Promise<AxiosResponse<TransferAccountOwnershipResponse>> => {
  return axios.post<TransferAccountOwnershipResponse>(
    `/api/v1/accounts/${accountId}`,
    keysToSnakeCase({
      action: 'transfer_account',
      newOwnerId,
      password,
    }),
  );
};
